import { FC } from "react";

import { MedalIcons } from "@euka-mfes/bark";

export const EUKA_FAMILIES = {
    EUKA_JUNIOR: "Euka-Junior",
    EUKA_SENIOR: "Euka-Senior",
    EUKA_KIDS: "Euak-Early-Age",
    EUKA_LEGACY: "Euka-Legacy"
};

export const SUBJECT_SELECTION = {
    ADD_SUBJECT_API: "ADD_SUBJECT_API",
    REMOVE_SUBJECT_API: "REMOVE_SUBJECT_API",
    ADD_EXT_SUBJECT_API: "ADD_EXT_SUBJECT_API",
    REMOVE_EXT_SUBJECT_API: "REMOVE_EXT_SUBJECT_API",
    ADD_SUBJECT_API_TOKEN: "ADD_SUBJECT_API_TOKEN",
    REMOVE_SUBJECT_API_TOKEN: "REMOVE_SUBJECT_API_TOKEN",
    ADD_EXT_SUBJECT_API_TOKEN: "ADD_EXT_SUBJECT_API_TOKEN",
    REMOVE_EXT_SUBJECT_API_TOKEN: "REMOVE_EXT_SUBJECT_API_TOKEN"
};

export const SUBJECT_TYPE = {
    COMPULSORY: "compulsory",
    CHOICE: "choice",
    EXTERNAL: "external",
    MANDATORY_BY_RULES: "mandatory_by_rules"
};

export const SUBJECT_SELECTION_ACTION_TYPE = {
    ADD: "ADD",
    REMOVE: "REMOVE"
};

export const GRADES = {
    GRADE_9: "G9",
    GRADE_10: "G10",
    GRADE_11: "G11",
    GRADE_12: "G12"
};

export const NUMERICAL_GRADE = Object.freeze({
    GRADE_11: 11,
    GRADE_12: 12
});

export const GRADES_LONG_NAME = {
    FOUNDATION: "Foundation",
    GRADE_10: "Grade 10",
    GRADE_11: "Grade 11",
    GRADE_12: "Grade 12"
};

export const LOCAL_STORAGE_SUBJECTS = "LOCAL_STORAGE_SUBJECTS";
export const LOCAL_STORAGE_SUBJECTS_CONFIG = "LOCAL_STORAGE_SUBJECTS_CONFIG";

export const REGISTRATION_FORM_TYPES = {
    TEXT: "text",
    DROPDOWN: "dropdown",
    PILLS: "pills",
    RADIO: "radio",
    INFO: "info",
    TEXTAREA: "textarea",
    CHECKBOX: "checkbox"
};

export const EXTERNAL_SERVICE_STATUS = {
    ACTIVE: "active",
    INACTIVE: "inactive",
    PROCESSING: "processing_request",
    FAILED: "failed_request"
};

export const TERM_NAME_MAP: { [key: string]: string } = {
    "1": "Term 1",
    "01": "Term 1",
    "2": "Term 2",
    "02": "Term 2",
    "3": "Term 3",
    "03": "Term 3",
    "4": "Term 4",
    "04": "Term 4"
};

export const GRADE_CODE_TO_GRADE_NAME_MAP: { [key: number]: string } = {
    1: "Foundation",
    10: "Grade 1",
    20: "Grade 2",
    30: "Grade 3",
    40: "Grade 4",
    50: "Grade 5",
    60: "Grade 6",
    70: "Grade 7",
    80: "Grade 8",
    90: "Grade 9",
    100: "Grade 10",
    110: "Grade 11",
    120: "Grade 12",
    901: "Clever Kids"
};

export const SUBJECT_MANAGEMENT_APPLICABLE_GRADE_CODES = [
    1, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120
];

export const GRADE_CODE_TO_PLP_MAP: { [key: number]: string } = {
    1: "F",
    10: "PLPG1",
    20: "PLPG2",
    30: "PLPG3",
    40: "PLPG4",
    50: "PLPG5",
    60: "PLPG6",
    70: "PLPG7",
    80: "PLPG8",
    90: "PLPG9",
    100: "PLPG10",
    110: "PLPG11",
    120: "PLPG12",
    901: "Clever Kids",
    999: "PLP"
};

export const PREMIUM_SERVICES = {
    GOVERMENT_REPORT_COMPILER: "government-report-compiler",
    REGISTRATION: "registration"
};

export const EXTERNAL_SERVICES = {
    MATHSPACE: "mathspace",
    MATIFIC: "matific",
    LITERACY_PLANET: "literacy_planet"
};

export const TERM_STEP_FIELDS = {
    STARTING_GRADE: "starting_grade",
    STARTING_TERM: "starting_term",
    GENERATED_TERM_PILLS: "generatedTermPills",
    GRADE_TERM: "grade_term",
    GENERATED_TERMS: "generatedTerms"
};

export const STATES = {
    NSW: "NSW",
    VIC: "VIC",
    QLD: "QLD",
    WA: "WA",
    NT: "NT",
    ACT: "ACT"
};

export const REQUEST_STATUS = {
    IDLE: "idle" as const,
    PENDING: "pending" as const,
    SUCCESS: "success" as const,
    ERROR: "error" as const,
    LOADING: "loading" as const,
    FAILED: "failed" as const
};

export const DUPLICATE_FILE_UPLOAD_ERROR = "You already uploaded this file!";
export const MARKING_PORTAL_FIRST_TIME_VISIT_LOCALSTORAGE_KEY =
    "is_marking_portal_first_visit";

export const RESOURCE_TYPE_HELPFUL_WEBSITE = "website";
export const RESOURCE_TYPE_OTHER_RESOURCES = "other";
export const RESOURCE_TYPE_SAMPLE_ASSESSMENTS = "sample_assessments";

export const QuizIconMap: Record<string, FC> = {
    bronze: MedalIcons.Bronze,
    silver: MedalIcons.Silver,
    gold: MedalIcons.Gold,
    diamond: MedalIcons.Diamond,
    notCompleted: MedalIcons.Empty,
    notAvailable: MedalIcons.Empty,
    pin: MedalIcons.Pin
};

export const ENTITLEMENTS_TTL_MS = 3 * 60 * 1000;
export const THREE_HOURS_MS = 3 * 60 * 60 * 1000;

export const TRANSCRIPT_SECTION_KEYS = {
    SUBJECT_PERFORMANCE_OVERVIEW: "subjectPerformanceOverview",
    HOMESCHOOLING_OVERVIEW: "homeschoolingOverview",
    HOMESCHOOLING_NOT_INCLUDED: "homeschoolingOverviewNotIncluded",
    ACHIEVEMENTS_HIGHLIGHTS: "achievementsHighlights",
    WORK_SAMPLES: "workSamples",
    WORK_SAMPLES_NOT_INCLUDED: "workSamplesNotIncluded"
} as const;

export type TranscriptSectionKey =
    (typeof TRANSCRIPT_SECTION_KEYS)[keyof typeof TRANSCRIPT_SECTION_KEYS];

export const SUBJECT_PERFORMANCE_OPTION_TEXT_MAP: { [key: string]: string } = {
    "Distinction":
        "Distinction (Advanced understanding, with independent application)",
    "Credit":
        "Credit (Confident, sound reasoning with mostly accurate application)",
    "Pass": "Pass (General understanding with basic, guided application)",
    "Needs Support":
        "Needs support (Limited understanding, with high guidance, or incomplete work)",
    "N/A": "N/A (Not applicable)"
};
